import { Recurrence } from '@tableau/self-service-schedules';
import { SelfServiceSchedulePaneType } from '@tableau/self-service-schedules/lib/src/components/SelfServiceSchedulePane';
import * as _ from 'underscore';
import { IRemoteRefreshScheduleTypeNameFilter } from '../filters/RemoteRefreshScheduleTypeNameFilter';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { Module } from '../Module';
import { RemoteRefreshSchedules } from '../resources/RemoteRefreshSchedules';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ChangeScheduleAction } from './ChangeScheduleAction';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ContentActionNotification } from './ContentActionNotification';
import { ICreateRemoteRefreshSelfServiceScheduleScope } from './CreateRemoteRefreshScheduleAction';
import { ModalService } from './ModalService';

export interface IEditRemoteRefreshSelfServiceScheduleScope extends ICreateRemoteRefreshSelfServiceScheduleScope {
  editRemoteRefreshPrompt: string;
}

export class EditRemoteRefreshScheduleAction {

  public static $inject = [
    '$translate',
    '$filter',
    'ConfirmActionDialog',
    'ContentActionNotification',
    'RemoteRefreshSchedules'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private $filter: ng.IFilterService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private ContentActionNotification: ContentActionNotification,
    private RemoteRefreshSchedules: RemoteRefreshSchedules) { }

  public execute(context: IActionContext,
      item: INamedItemInfo,
      schedule: IRemoteRefreshScheduleInfo,
      availableTypes: string[],
      changeScheduleAction: ChangeScheduleAction): ng.IPromise<IResult> {

    return this.openDialogWithSSSWidget(context, item, schedule, availableTypes, changeScheduleAction);
  }

  private openDialogWithSSSWidget(context: IActionContext,
    item: INamedItemInfo,
    schedule: IRemoteRefreshScheduleInfo,
    availableTypes: string[],
    changeScheduleAction: ChangeScheduleAction): ng.IPromise<IResult> {
      const scope = <IEditRemoteRefreshSelfServiceScheduleScope>context.scope.$new();
      changeScheduleAction.setupSelfServiceScheduleDialogScope(scope,
        schedule.scheduleDetails, true, schedule.timeZone, schedule.scheduleType,
        SelfServiceSchedulePaneType.BridgeExtractRefresh);
      scope.availableTypeOptions = availableTypes;
      scope.scheduleInfo = {
        refreshType: schedule.refreshType,
      };
      scope.editRemoteRefreshPrompt =
        this.$translate.instant('editRemoteRefreshScheduleCustomDialogPrompt', {DATASOURCE_NAME: L10n.elideIfLong(item.name)});

      const action = () => {
        const recurrenceModel: Recurrence = scope.selfServiceSchedulePaneProps.recurrenceModel;
        const finalSchedule: IRemoteRefreshScheduleInfo = {
          id: schedule.id,
          contentType: schedule.contentType,
          definition: null,
          scheduleDetails: recurrenceModel.recurrenceDetails,
          scheduleType: recurrenceModel.recurrenceType,
          refreshType: scope.scheduleInfo.refreshType
        };
        return this.RemoteRefreshSchedules.update(item.id, schedule, finalSchedule);
      };
      const confirmDisabled = () => false;

      return this.openDialog(context, 'confirmActionDialogEditRemoteRefreshSelfServiceSchedule.html',
        action, confirmDisabled, scope, () => scope.scheduleInfo.refreshType);
  }

  private openDialog(context: IActionContext,
    bodyTemplateUrl: string,
    action: (confirmActionDialogInstance: IConfirmActionDialogInstance) => any,
    confirmDisabled: () => boolean,
    scope: ng.IScope,
    getRefreshType: () => string): ng.IPromise<IResult> {
    const dialogInstance = this.ConfirmActionDialog.open({
      title: this.$translate.instant('editRemoteRefreshScheduleDialogTitle'),
      bodyTemplateUrl: bodyTemplateUrl,
      size: '500px',
      scope: scope,
      position: _.extend(ModalService.anchoredTo(context.targetElement), {reserveHeight: 600}),
      actionName: this.$translate.instant('editRemoteRefreshSchedule'),
      action: action,
      confirmDisabled: confirmDisabled,
    });
    return dialogInstance.result
    .then((result: IResult) => {
      if (result.errors && result.errors.length) {
        const errorMessage = this.errorMessageFor(result.errors[0]);
        dialogInstance.showErrorMessage(errorMessage);
      } else {
        this.ContentActionNotification.notifySuccess(
          this.$translate.instant('editRemoteRefreshScheduleSuccess',
            { REFRESH_TYPE_NAME: this.$filter<IRemoteRefreshScheduleTypeNameFilter>('remoteRefreshScheduleTypeName')(getRefreshType()) })
        );
      }
      return result;
    })
    .finally(() => scope.$destroy());
  }

  private errorMessageFor(error: IError) {
    return this.$translate.instant('errorUnknown');
  }

}

Module.instance().service('EditRemoteRefreshScheduleAction', EditRemoteRefreshScheduleAction);
